export class ResetPasswordRequest {
  email: string;
  token: string;
  password: string;
  confirmation: string;

  constructor(email: string, token: string, password: string, confirmation: string) {
    this.email = email;
    this.token = token;
    this.password = password;
    this.confirmation = confirmation;
  }
}
